
<div mat-dialog-title class="titlePanel">
    <label>{{ title }}</label> 
</div>
<div mat-dialog-content class="container">
    <p>{{ message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-button class="btnAccept" (click)="onAccept()">Aceptar</button>
</div>
